import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  ActivatedRoute,
} from "@angular/router";
import { Platform, NavController, MenuController } from "@ionic/angular";
import { AuthService } from "./auth.service";
import { AppConfig } from "./app.config";
import { IonicService } from "./ionic.service";
import { GlobalService } from "./global.service";
import { GenericService } from "./generic.service";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    public authService: AuthService,
    private platform: Platform,
    private navCtrl: NavController,
    private menu: MenuController,
  ) {}

  canViewPage(path) {
    if (!GlobalService.user) {
      this.navigate("/login");
      return false;
    }

    path = path.split("?")[0];
    if (path == "/login") return true;

    let page = GlobalService.getMenuItemByPath(path);
    if (page) {
      if (page.role) {
        var user = GlobalService.user;
        if (!user || !user.Role) return false;
        else return user.Role.toLowerCase() == page.role.toLowerCase();
      }
    }
    return true;
  }
  canViewPagewithrole(path, role) {
    if (!GlobalService.user) {
      this.navigate("/login");
      return false;
    }

    path = path.split("?")[0];
    if (path == "/login") return true;

    let page = GlobalService.getMenuItemByPathwithRole(path, role);
    if (page) {
      if (page.role) {
        var user = GlobalService.user;
        if (!user || !user.Role) return false;
        else return user.Role.toLowerCase() == page.role.toLowerCase();
      }
    }
    return true;
  }
  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    await this.initApp();
    await this.authService.isLoggedin();

    let canView = await this.canViewPage(state.url);
    return canView;
  }

  async initApp() {
    if (AppConfig.isApp && !AppConfig.isAppLoaded) {
      await this.platform.ready();
      AppConfig.isAppLoaded = true;
    }
  }

  navigateToDefaultPage() {
    if (!GlobalService.user) this.navigate("/login");
    else {
      this.menu.enable(true);
    }
  }

  navigate(url, params = null, queryParams = null) {
    let path = [url];
    if (params) path.push(params);

    queryParams = queryParams || {};

    this.navCtrl.navigateForward(path, { queryParams: queryParams });
  }
}
